import { trackOrderValidation } from "@/utils/valitation/track-order";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { useTranslation } from "next-i18next";
import { useRef } from "react";

import Input from "../forms/Input";
import CloseIcon from "../icons/CloseIcon";
import Loading from "@/components/global/Loading";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { useRouter } from "next/router";

const TrackOrderModal = ({ Context }) => {
  const ref = useRef();
  const router = useRouter();
  useOnClickOutside([ref], () => Context?.dispatch({ type: "trackOrder" }));
  const { t } = useTranslation("common");
  const onSubmit = (values) => {
    router.push({
      pathname: "/track-order",
      query: { order_number: values.order_number, email: values.email },
    });
    Context?.dispatch({ type: "trackOrder" });
  };
  useBodyScrollLock();
  return (
    <div
      ref={ref}
      className="w-11/12 sm:w-[640px] bg-white rounded-md max-h-[85vh] overflow-y-auto p-3"
    >
      <div className="flex items-center justify-between pb-2 border-b">
        <h2 className="font-bold sm:text-xl">{t("Track Order")}</h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "trackOrder" })}
          className="cursor-pointer text-secondary-800 size-3 sm:size-4"
        />
      </div>

      <p className="my-4 text-center max-sm:text-sm">
        <span className="font-bold text-secondary-800">
          {t("To Track Your Order")}
        </span>{" "}
        <span className="font-semibold text-zinc-500">
          {t(",Please Fill this Data.")}
        </span>
      </p>

      <Formik
        onSubmit={onSubmit}
        initialValues={{ email: "", order_number: "" }}
        validationSchema={trackOrderValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="mb-3 col-span-full sm:col-span-1">
              <div className="flex items-center gap-1 border rounded-sm max-sm:py-1">
                <Field
                  name="email"
                  type="email"
                  placeholder={t("Email Address")}
                  id="email"
                  className="outline-none border-none sm:p-1.5 flex-1 max-sm:placeholder:text-xs max-sm:text-sm"
                />
              </div>
              <ErrorMessage
                name="email"
                component="p"
                className="text-sm text-warning max-sm:text-xs"
              />
            </div>
            <div className="mb-3">
              <Input
                name="order_number"
                id="order_number"
                type="text"
                placeholder={t("Order Number")}
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>
            <button
              className="bg-primary text-white max-sm:text-sm p-1.5 rounded-md w-full font-semibold"
              type="submit"
            >
              {isSubmitting ? <Loading /> : t("Track Order")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TrackOrderModal;
